
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/multimedia/[...slug]",
      function () {
        return require("private-next-pages/multimedia/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/multimedia/[...slug]"])
      });
    }
  